// extracted by mini-css-extract-plugin
export default {"linkContainer":"LinkMenu_linkContainer__6B7iX"};